/**
 * Versions de ce que la transparence salariale calcule, pour les mémoires de réponses des onglets.
 *
 * - Version de la population : sortir un salarié des calculs — ou l'y remettre —, une décision sur un
 *   montant négatif, une proposition de correction changent la population sur laquelle le serveur
 *   calcule les écarts. Tous les onglets en dépendent.
 * - Version du modèle : enregistrer, copier ou retirer un réglage de critères change le modèle
 *   lui-même, mais aucun chiffre des Indicateurs, de la Décomposition, du Fixe ni des Éléments
 *   complémentaires. Seuls les onglets qui lisent le modèle (Critères, Population, Salarié) et la
 *   lecture des réglages en dépendent (audit P-11).
 *
 * Les hooks qui mettent une réponse serveur en cache intègrent la ou les versions à leur clé : après
 * une décision, la lecture suivante repart du serveur au lieu de resservir des chiffres périmés, y
 * compris dans un autre onglet.
 */
let version = 0
let modelVersion = 0

export const getPopulationVersion = () => version

export const bumpPopulationVersion = () => {
    version += 1
}

export const getModelVersion = () => modelVersion

export const bumpModelVersion = () => {
    modelVersion += 1
}
